const conditionsHolder = document.querySelector('.conditions-holder');
const productSpec = document.querySelector('product-spec');
const viewMoreButton = document.querySelector('.button-more-holder');
// Function to set CSS variable based on .conditions-holder height
function updateViewerWrapperHeight() {
  if (conditionsHolder && productSpec) {
    // Get the height of .conditions-holder
    const conditionsHeight = conditionsHolder.offsetHeight - 60 - viewMoreButton.offsetHeight;
    
    // Set the height as a CSS variable on .product-spec
    productSpec.style.setProperty('--viewer-wrapper-height', `${conditionsHeight}px`);
  }
}

// Call the function on load
updateViewerWrapperHeight();

// Optionally, call on window resize if the height may change
window.addEventListener('resize', updateViewerWrapperHeight);

function reinitializeProductZoom() {
  if (typeof ProductImageZoom !== 'undefined') {
    new ProductImageZoom();
  }
}

document.querySelectorAll('.conditions-holder .accordion details').forEach(detail => {
  detail.addEventListener('toggle', event => {
    // Check if the current <details> element is being opened
    if (event.target.open) {
      // Find all sibling .accordion elements including the current one
      const allAccordions = document.querySelectorAll('.conditions-holder .accordion');
      reinitializeProductZoom();
      // Loop through each .accordion and its <details> elements
      allAccordions.forEach(accordion => {
        accordion.querySelectorAll('details').forEach(otherDetail => {
          // Close all <details> elements except the one that triggered the event
          if (otherDetail !== event.target) {
            otherDetail.removeAttribute('open');
          }
        });
      });
      updateViewerWrapperHeight();
    }
  });
});

document.querySelectorAll('.categorias-link').forEach(link => {
    link.addEventListener('click', function () {
        console.log('categoria link clicked');

        // Get the data-title value of the clicked link
        const title = this.getAttribute('data-title');
        console.log('data-title of clicked link:', title);

        // Find the matching <product-spec> element
        const matchingProductSpec = document.querySelector(`product-spec`);
        console.log('looking for selector:', `product-spec`);

        if (matchingProductSpec) {
            console.log('product-spec element found');
            
            // Get the position of the <product-spec> element
            const rect = matchingProductSpec.getBoundingClientRect();
            const scrollPosition = rect.top + window.pageYOffset - 0; // 50px offset

            // Smooth scroll to the element with 100px offset from the top
            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });

            // Optionally, open the associated <details> element if needed
            const detailsElement = document.querySelector(`details[data-title="${title}"]`);
            if (detailsElement) {
                detailsElement.open = true;
            }
        } else {
            console.log('product-spec element not found');
        }
    });
});







const descriptionHolder = document.querySelector('.description-holder');

// Function to add the 'active' class to .description-holder on click
function addActiveClass() {
  if (descriptionHolder) {
    descriptionHolder.classList.add('active');
  }
}

// Add click event listener to .view-more-button
if (viewMoreButton) {
  viewMoreButton.addEventListener('click', addActiveClass);
}
 
 $(document).ready(function(){

  var modelViewer = $('.model-viewer')[0];
   
    $('.model-viewer').on('load', function(){
      console.log('model ready');
      var loadModel = $(this);
      
      //loadModel.parents('.model-holder').css('display', 'none');
      setTimeout(function(){
      //loadModel.parents('.model-holder').css('display','block');
      }, 1000);
        
      
      modelViewer.shadowIntensity = 0;
    })
    
    $('.position-option').click(function(){
    var newPos = $(this).data('position');
      modelViewer.cameraOrbit = newPos;
    })
    
  $('.model-viewer').on('camera-change', function(e){
    
    var target = modelViewer.getCameraOrbit();
    //console.log(target.toString());
    
  });
  })